export default function roundUpToFractionDigits(
  value: number,
  fractionDigits: number,
) {
  const factor = 10 ** fractionDigits;

  return Math.ceil(Number((value * factor).toFixed(6))) / factor;
}
